import { FetchService } from "./services/fetchService";

class ConfigPtza {

    #existConfigFile = false;
    #configObj = null;
    #fetchService = new FetchService();

    //LOAD CONFIG
    async loadConfig() {
        const pageConfig = this.normalizeConfig(window.PTZA_PAGE_CONFIG, 'page');
        const modo = pageConfig?.ptza?.modo ?? 'local';
        let configFile = null;

        if(modo == 'api') {
            configFile = await this.#fetchService.loadJSONFile('/ptza_core/client/config.json');
            configFile = this.normalizeConfig(configFile, 'file');
        }

        if (configFile) {
            this.#existConfigFile = true;
            this.#configObj = configFile;
            this.#configObj.page = (pageConfig && pageConfig.page) ? pageConfig.page : {};
        }else{
            if (Object.keys(pageConfig).length > 0) {
                this.#existConfigFile = false;
                this.#configObj = pageConfig;
            }
        }

        if (this.#configObj) {
            return true;
        }

        console.error("No se ha enontrado configuración de Propuestaza. Revise la información técnica para saber más.")
        this.#existConfigFile = false;
        this.#configObj = null;
        return false;
    }

    normalizeConfig(config, source = 'file') {
        if (!config) return null;
            
        if(typeof config !== 'object') {
            try{
                config = JSON.parse(config);
            }catch(e){
                return null;
            }
        }

        const normalized = {
            environment: config.environment || 'prod',

            ptza: {
                apiPTZAUrl: config?.ptza?.apiPTZAUrl || '',
                publicKeyClient: config?.ptza?.publicKeyClient || '',
                clientID: config?.ptza?.clientID || ''
            },

            clientInfo: {
                nombreCliente: config?.clientInfo?.nombreCliente || '',
                clientDomain: config?.clientInfo?.clientDomain || '',
                clientProtocol: config?.clientInfo?.clientProtocol || '',
                urlCliente: config?.clientInfo?.urlCliente || '',

                uriTree:{
                    assets:{
                        logoUri: config?.clientInfo?.uriTree?.assets?.logo || '',
                    },
                    tienda:{
                        home: config?.clientInfo?.uriTree?.tienda?.home || '/index.html',
                        carrito: config?.clientInfo?.uriTree?.tienda?.carrito || '/carrito.html',
                        checkout: config?.clientInfo?.uriTree?.tienda?.checkout || '/checkout.html',
                        resumen: config?.clientInfo?.uriTree?.tienda?.resumen || '/resumen-pedido.html',
                        item: config?.clientInfo?.uriTree?.tienda?.item || '/item/ver.html',
                        buscadorItem: config?.clientInfo?.uriTree?.tienda?.buscadorItem || '/buscar-item.html',
                        pagar: config?.clientInfo?.uriTree?.tienda?.pagar || '/pagar.html'
                    },
                    web:{
                        home: config?.clientInfo?.uriTree?.web?.home || '/index.html',
                        tyc: config?.clientInfo?.uriTree?.web?.tyc || '/terminos-y-condiciones.html',
                        ayuda: config?.clientInfo?.uriTree?.web?.ayuda || '/ayuda/ver.html',
                        noticia: config?.clientInfo?.uriTree?.web?.noticia || '/noticia/ver.html',
                        contacto: config?.clientInfo?.uriTree?.web?.contacto || '/contacto.html'
                    }
                },               

                numeroCelular: config?.clientInfo?.numeroCelular || '',
                numeroTelefono: config?.clientInfo?.numeroTelefono || '',
                direccion: config?.clientInfo?.direccion || '',
                email: config?.clientInfo?.email || '',
                
                facebook: config?.clientInfo?.facebook || '',
                tiktok: config?.clientInfo?.tiktok || '',
                instagram: config?.clientInfo?.instagram || '',
                youtube: config?.clientInfo?.youtube || '',
                footerDescription: config?.clientInfo?.footerDescription || '',
                horarioComercial: config?.clientInfo?.horarioComercial || '',
            },

            page: config?.page || {}
        };

        if (!this.validateNormalizedConfig(normalized, source)) {
            return null;
        }

        return normalized;
    }

    validateNormalizedConfig(config, source = 'file') {
        const requiredBase = [
            config.ptza.clientID,
            config.ptza.publicKeyClient,
            config.clientInfo.clientDomain,
            config.clientInfo.clientProtocol,
            config.clientInfo.urlCliente,
            config.clientInfo.uriTree,
            config.clientInfo.numeroCelular,
            config.clientInfo.email
        ];

        const requiredFile = [
            config.ptza.apiPTZAUrl,
            config.clientInfo.nombreCliente,
            config.clientInfo.clientDomain,
            config.clientInfo.clientProtocol
        ];

        const required = source === 'file'
            ? [...requiredBase, ...requiredFile]
            : requiredBase;

        const isValid = required.every(v => v !== undefined && v !== null && v !== '');

        if (!isValid) {
            console.error(`Config incompleto para modo ${source}`);
            return false;
        }

        return true;
    }

    getConfig() {
        return this.#configObj;
    }

    getPageConfig() {
        return this.#configObj?.page || null;
    }

    getClientInfoValue(key, fallback = null) {
        const config = this.#configObj?.clientInfo;

        if (!config || typeof config !== 'object') {
            return fallback;
        }

        return config[key] ?? fallback;
    }

    getPtzaValue(key, fallback = null) {
        const config = this.#configObj?.ptza;

        if (!config || typeof config !== 'object') {
            return fallback;
        }

        return config[key] ?? fallback;
    }

    getPageValue(key, fallback = null) {
        const config = this.#configObj?.page;

        if (!config || typeof config !== 'object') {
            return fallback;
        }

        return config[key] ?? fallback;
    }

    getUri(type, key, fallback = null){
        const config = this.getClientInfoValue("uriTree");

        if (!config || typeof config !== 'object') {
            return fallback;
        }

        return config[type][key] ?? fallback;
    }

    existConfigFile(){
        return this.#existConfigFile;
    }

    isLoadConfig(){
        return (this.#configObj)?true:false;
    }
}

export const ptzaConfig = new ConfigPtza();
